import { render, staticRenderFns } from "./userInvoices.vue?vue&type=template&id=0ad8e6d1"
import script from "./userInvoices.vue?vue&type=script&lang=js"
export * from "./userInvoices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports